import script from "./ProjectTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectTooltip.vue?vue&type=style&index=0&id=4e4c9a47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4c9a47"]])

export default __exports__